import React, {Component} from "react";
import {Link} from "react-router-dom";
import Bounce from "react-reveal/Bounce";

import Flash from "react-reveal/Flash";
import {get_shared_table} from "./shared-components";

class SureBuilt2026Conference extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        document.getElementById("header").scrollIntoView();
    }

    render() {
        let image_margin = "20px 0 0 0";
        let marginTop = "5%";

        if (window.innerWidth < 850) {
            image_margin = "-40px 0px 0px 0px";
            marginTop = "20%";
        }

        return (
            <div style={{ marginTop: "80px" }}>
                <section class="call-to-action-box no-padding">
                    <div class="container" style={{ marginBottom: "20px" }}>
                        <div class="action-style-box">
                            <h2 class="column-title" style={{ color: "black", textAlign: "center" }}>
                                CONFERENCE OVERVIEW - SURE-Built 2026<br/>

                                Built Environment Epistemologies: Crafting Sustainable Knowledge in the GenAI Era</h2>
                        </div>
                    </div>
                </section>

                <Bounce right fraction={0.01}>
                    <section id="main-container" class="main-container">
                        <div class="container" style={{marginTop: "-50px"}}>

                            {get_shared_table(image_margin)}
                            <hr/>
                            <div class="row" style={{marginTop: marginTop}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">Background</h3>
                                    </Bounce>

                                    <p>The 2nd Global Scholarship for Sustainable Built Environment Research Conference (SURE-Built 2026), with the theme “Built Environment Epistemologies: Crafting Sustainable Knowledge in the GenAI Era”, centres on the intersection of traditional knowledge systems and emergent technologies in shaping sustainable built environments in developing countries. The theme interrogates the emerging influence of GenAI in revolutionising activities within the built environment by introducing innovative design methodologies and predictive analytics, thereby fostering sustainable practices. Epistemology, the philosophical study of knowledge, is critical in this current era of GenAI as it assesses how knowledge is created, shared, and validated within the built environment, particularly in developing countries.</p>
                                    <p> In this age of GenAI, traditional and new forms of knowledge relate, prompting questions about authenticity, ethics, and future implications. As such, SURE-Built 2026 aims to bring together interdisciplinary experts to discuss strategies for integrating GenAI into sustainable knowledge creation and built environment development.
                                    </p>
                                    <p>SURE-Built 2026 builds on the free-to-attend model of the Global Scholarship for Sustainable Built Environment Research Conference, which is rooted in inclusivity and aligns with a broader mission to promote sustainable development in line with global goals. The interdisciplinary focus of the conference encourages collaboration among architects, engineers, urban planners, environmental scientists, and policymakers, thus creating a comprehensive approach to crafting sustainable knowledge for the built environment in the era of GenAI. This conference model does not merely aim to remove financial barriers but aspires to reshape the standard academic landscape by prioritising accessibility, equity, and actionable impact.
                                    </p>
                                </div>
                            </div>

                            <div class="row" style={{marginTop: "2%"}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">Important Dates</h3>
                                    </Bounce>

                                    <ul>
                                        <li>Deadline for Submission of Abstracts - 31st January, 2026</li>

                                        <li>Notification of Acceptance of Abstracts – 1st March, 2026</li>

                                        <li>
                                            Deadline for Submission of Papers – 31st May, 2026

                                        </li>

                                        <li>Notification of Decision on Papers – 15th July, 2026</li>

                                        <li>Deadline for Submission of Draft Papers – 15th of August, 2026</li>


                                    </ul>
                                </div>
                            </div>


                            <div class="row" style={{marginTop: "2%"}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">AWARDS</h3>
                                    </Bounce>

                                    <ul>
                                        <li>Best track paper award</li>

                                        <li>Overall best paper award
                                        </li>


                                    </ul>
                                </div>
                            </div>

                            <div class="row" style={{marginTop: "2%"}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">Publication</h3>
                                    </Bounce>
                                    <p style={{color: "red", fontWeight: "bold"}}>Conference Proceedings will be
                                        published in a Springer Edited Book series – Lecture Notes in Civil Engineering
                                        Submitted for indexing to Scopus and EI-Compendex, and Springerlink.</p>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            justifyContent: "start",
                                            alignItems: "center",
                                            gap: "20px",
                                            marginTop: "20px",
                                        }}
                                    >
                                        <img
                                            src="images/scopus.png"
                                            alt="scopus"
                                            style={{
                                            maxWidth: "200px",
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain",
                                            }}
                                        />

                                        <img
                                            src="images/springer.png"
                                            alt="springer"
                                            style={{
                                            maxWidth: "200px",
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain",
                                            }}
                                        />
                                        <img
                                            src="images/el-compendex.png"
                                            alt="compendex"
                                            style={{
                                            maxWidth: "200px",
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                    <hr/>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: "2%" }}>
                                <div className="col-lg-12">
                                    <Bounce left>
                                    <h3 className="column-title">Endorsements</h3>
                                    </Bounce>

                                    <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: "start",
                                        alignItems: "center",
                                        gap: "20px",
                                        marginTop: "20px",
                                    }}
                                    >
                                    <img
                                        src="images/ciob.png"
                                        alt="CIOB"
                                        style={{
                                        maxWidth: "200px",
                                        width: "100%",
                                        height: "auto",
                                        objectFit: "contain",
                                        }}
                                    />

                                    <img
                                        src="images/cidb.png"
                                        alt="CIDB"
                                        style={{
                                        maxWidth: "200px",
                                        width: "100%",
                                        height: "auto",
                                        objectFit: "contain",
                                        }}
                                    />
                                    </div>
                                </div>
                            </div>

                            <div class="row" style={{marginTop: "2%"}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">Conference Contact</h3>
                                    </Bounce>

                                    <p>For more information or any queries send an email to: <span
                                        style={{color: "red"}}> <b>surebuiltseries@gmail.com</b></span></p>
                                </div>
                            </div>
                        </div>
                    </section>
                </Bounce>

                <section class="call-to-action-box no-padding">
                    <div class="container" style={{marginBottom: "20px"}}>
                    <div class="action-style-box">
                            <div class="row align-items-center">
                                <div class="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <div class="call-to-action-btn">
                                        <Flash count={2}>
                                            <Link to="/2026-sure-built-conference-information">
                                                {" "}
                                                <a class="btn btn-dark">Conference Information</a>{" "}
                                            </Link>
                                        </Flash>
                                    </div>
                                </div>
                                <div class="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <div class="call-to-action-btn">
                                        <Flash count={2}>
                                            <Link to="/2026-sure-built-conference-submissions">
                                                {" "}
                                                <a class="btn btn-dark">Paper Submissions</a>{" "}
                                            </Link>
                                        </Flash>
                                    </div>
                                </div>
                                <div class="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <div class="call-to-action-btn">
                                        <Flash count={2}>
                                            <Link to="/">
                                                {" "}
                                                <a class="btn btn-dark">Back to CR Centre</a>{" "}
                                            </Link>
                                        </Flash>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


export default SureBuilt2026Conference